import { render, staticRenderFns } from "./AnmeldungenlisteSKJV.vue?vue&type=template&id=3c9adb36"
import script from "./AnmeldungenlisteSKJV.vue?vue&type=script&lang=js"
export * from "./AnmeldungenlisteSKJV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports